import { actionTypes, mutationTypes } from '@/core/constants'
import api from '@/core/apiclient/configuracao/ParametrosSistemaApiClient'

export default {
	async [actionTypes.COMUM.BUSCAR_PARAMETROS_SISTEMA]({ commit }) {
		const { data } = await api.buscarTodosParametros()
		commit(mutationTypes.COMUM.SET_PARAMETROS_SISTEMA, data)
	},
}
